
import React, { Fragment as F, createContext, useEffect, useLayoutEffect, useState } from 'react'
import { ReactKeycloakProvider, useKeycloak } from '@react-keycloak/web'

import Modal from 'react-modal'
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate, useParams,
} from "react-router-dom"

import config from 'config'


import {
  BanksProvider,
} from './components/banks'
import {
  FintegrationProvider,
} from './components/fintegration'
import {
  PeriodsProvider,
} from './components/periods'
import {
  QueriesProvider,
} from './components/queries'
import {
  ReportsProvider,
} from './components/reports'
import {
  SchedulesProvider,
} from './components/schedules'
import authClient from './keycloak'
import LayoutTop from './LayoutTop'
import {
  appRouter,
  C,
  logg,
  useApiRouter,
} from './shared'


const AppCtx = createContext({
  statesList: [],
})

// Modal.setAppElement('#root')

/**
 * AppProvider
**/
const AppProvider = ({ children, ...props }) => {
  // logg(props, 'AppProvider')
  const {
    jwtToken: defaultJwtToken,
  } = props

  const { keycloak, initialized } = useKeycloak()
  // logg(keycloak, 'keycloak')

  const apiRouter = useApiRouter()

  const [ actionName, setActionName ] = useState(null)
  const [ breadcrumbsActions, setBreadcrumbsActions ] = useState(null)
  const [ cuEmail, setCuEmail ] = useState( null )
  const [ currentUser, setCurrentUser ] = useState({ roles: [] })
  const [ customerId, setCustomerId ] = useState( null )
  const [ deleteModalOpen, setDeleteModalOpen ] = useState(false)
  const [ drawerOpen, setDrawerOpen ] = useState(C.classes.sidebarIsOpen)
  const [ joyrideOpen, setJoyrideOpen ] = useState(false)
  const [ joyrideRun, setJoyrideRun ] = useState(true)
  const [ joyrideStepIdx, setJoyrideStepIdx ] = useState(0)
  const [ jwtToken, setJwtToken ] = useState(defaultJwtToken)
  const [ renameModalOpen, setRenameModalOpen ] = useState(false)
  const [ unauthorized, setUnauthorized ] = useState(false)

  const themeNames = [ 'theme-eagle', 'theme-dark', 'theme-light' ]
  const defaultUserConfig = {
    dateFormat: 'MM/DD/YYYY', // confirmed on 2025-02-25
    themeName: themeNames[0],
  }
  const [ userConfig, _setUserConfig ] = useState(JSON.parse(localStorage.getItem('userConfig')) || defaultUserConfig)
  const setUserConfig = (ev) => {
    localStorage.setItem('userConfig', JSON.stringify(ev))
    _setUserConfig(ev)
  }

  const [ themeName, setThemeName ] = useState(userConfig.themeName)
  const nextTheme = () => {
    const idx = themeNames.indexOf(themeName)
    const nextIdx = idx === themeNames.length-1 ? 0 : idx+1
    setThemeName(themeNames[nextIdx])
    document.body.classList.remove(themeNames[idx])
    document.body.classList.add(themeNames[nextIdx])

    const tmp = {...userConfig}
    tmp.themeName = themeNames[nextIdx]
    setUserConfig(tmp)
  }
  useEffect(() => {
    document.body.classList.add(userConfig.themeName)
  }, [])

  const [ charterAuthoritiesList, setCharterAuthoritiesList ] = useState([])
  const [ charterTypesList, setCharterTypesList ] = useState([])
  const [ params, setParams ] = useState({})

  const [ selectedResource, setSelectedResource ] = useState({ share_with_str: '', is_shared: false })
  const defaultSelectedResource = { is_shared: false, shared_with_str: '' }
  const [ scope,   _setScope ] = useState(C.scope.default)
  const setScope = (which) => {
    setSelectedResource(defaultSelectedResource)
    _setScope(which)
  }
  const [ showEulaModal, setShowEulaModal ] = useState(false)
  const [ eulaBody, setEulaBody ] = useState('')
  const [ msasList, setMsasList ] = useState([])
  const [ statesList, setStatesList ] = useState([])
  const [ tradingTypesList, setTradingTypesList ] = useState([])

  const [ logout, setLogout ] = useState(null)

  const [ loading, _setLoading ] = useState(0)
  const setLoading = (which, prev) => {
    if (which) {
      _setLoading(prev => prev + 1)
    } else {
      _setLoading(prev => prev - 1)
    }
  }
  const [ loading2, setLoading2 ] = useState(false)

  /* effects */

  /* keycloak */
  useEffect(() => {
    if (config.skip_keycloak) { return; }
    if (initialized) {
      if (keycloak.idTokenParsed) {
        setJwtToken(keycloak.idToken)
        setCuEmail(keycloak.idTokenParsed.email)

        const _logout = () => {
          return () => {
            keycloak.logout({ redirectUri: config.keycloak_logout_redirect_url })
          }
        }
        setLogout(_logout)

        fetch(apiRouter.userPath({ jwtToken: keycloak.idToken })).then(r => r.json()).then(inns => {
          // setPeriodYtd0(inns.period_ytd0)
          if (!inns.user.accepted_eula) {
            const url = `${config.drupalOrigin}/docpage/eula?_format=json`
            fetch(url).then(r => r.json()).then(inns => {
              // logg(inns, 'inns')
              setEulaBody(inns.body[0].value)
            })
            setShowEulaModal(true)
          }
          setCustomerId(inns.user.customer_id)
          setCurrentUser(inns.user)
          logg(inns.user, 'got current user')
        })
      } else {
        keycloak.login()
      }
    }
  }, [ initialized ])

  /* statesList */
  useEffect(() => {
    if (jwtToken) {
      fetch(apiRouter.statesListPath({ jwtToken }), {
      }).then(r => r.json()).then(inns => {
        // logg(inns, 'got States List')
        setStatesList(inns.map(s => ({ label: s.abbr, value: s.abbr }) ) )
      })

      fetch(apiRouter.msasListPath({ jwtToken }), {
      }).then(r => r.json()).then(inns => {
        // logg(inns, 'got Msas List')
        setMsasList(inns)
      })

      fetch(apiRouter.charterAuthoritiesPath({ jwtToken }), {
      }).then(r => r.json()).then(inns => {
        setCharterAuthoritiesList(inns)
      })

      fetch(apiRouter.charterTypesPath({ jwtToken }), {
      }).then(r => r.json()).then(inns => {
        setCharterTypesList(inns)
      })

      fetch(apiRouter.tradingTypesPath({ jwtToken }), {
      }).then(r => r.json()).then(inns => {
        setTradingTypesList(inns)
      })
    }
  }, [ jwtToken ])

  /* methods */

  const acceptEula = () => {
    // logg(keycloak.idToken, 'jwtToken in acceptEula')
    fetch(apiRouter.acceptEulaPath({ jwt_token: jwtToken }), {
      method: 'POST',
    }).then(r => r.json()).then(inns => {
      // logg(inns, 'accepted')
      if ('OK' === inns.status) {
        setShowEulaModal(false)
      }
    })
  }

  return <AppCtx.Provider value={{
    actionName, setActionName,
    breadcrumbsActions, setBreadcrumbsActions,
    charterAuthoritiesList,
    charterTypesList,
    cuEmail, setCuEmail,
    currentUser, setCurrentUser,
    customerId, setCustomerId,
    deleteModalOpen, setDeleteModalOpen,
    drawerOpen, setDrawerOpen,
    joyrideOpen, setJoyrideOpen,
    joyrideRun, setJoyrideRun,
    joyrideStepIdx, setJoyrideStepIdx,
    jwtToken, setJwtToken,
    loading, setLoading,
    loading2, setLoading2,
    logout, setLogout,
    msasList,
    params, setParams,
    renameModalOpen, setRenameModalOpen,
    scope, setScope,
    selectedResource, setSelectedResource, defaultSelectedResource,
    statesList,
    tradingTypesList,
    themeName, setThemeName, nextTheme,
    unauthorized, setUnauthorized,
    userConfig, setUserConfig,
  }} >
    <div className={`App ${themeName}`} >
      { children }
      <Modal
        className=" EulaModal BaseModal "
        isOpen={showEulaModal}
        overlayClassName="EulaModalOverlay"
      >
        <div className='header'>
          You must accept EULA to continue.
        </div>
        <div className='body' dangerouslySetInnerHTML={{ __html: eulaBody }} >
        </div>
        <div className='actions'>
          <div className='left'></div>
          <div className='right'>
            <button onClick={acceptEula} >I accept</button>
          </div>
        </div>
      </Modal>
    </div>
  </AppCtx.Provider>
}

/**
 * App
**/
function App() {
  return <ReactKeycloakProvider authClient={authClient} >
    <AppProvider >
      <FintegrationProvider>
        <PeriodsProvider>
          <QueriesProvider>
            <ReportsProvider>
              <SchedulesProvider>
                <BanksProvider>
                  <Router>
                    <LayoutTop />
                  </Router>
                </BanksProvider>
              </SchedulesProvider>
            </ReportsProvider>
          </QueriesProvider>
        </PeriodsProvider>
      </FintegrationProvider>
    </AppProvider>
  </ReactKeycloakProvider>
}

export default App
export {
  AppCtx,
  AppProvider,
}
